(function (){
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = window.matchMedia('(max-width: 800px)').matches;

  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    // GSAP didn't load. Reveal everything immediately so content is visible.
    document.querySelectorAll('[data-anim]').forEach(function (el) { el.classList.add('is-in'); });
    document.querySelectorAll('.cta-card').forEach(function (el) {
      el.style.transform = 'none';
      el.style.opacity = '1';
    });
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  // ============================================================
  // 1) LENIS SMOOTH SCROLL (free, MIT)
  //    Provides the buttery lerped scroll feel and is bridged
  //    to ScrollTrigger so pin animations stay in sync.
  // ============================================================
  var lenis = window.lenis || null;

  if (!lenis && typeof Lenis !== 'undefined' && !prefersReducedMotion) {
    lenis = new Lenis({
      duration: 1.4,
      easing: function(t) {
        return Math.min(1, 1.001 - Math.pow(2, -10 * t));
      },
      smoothWheel: true,
      smoothTouch: false,
      wheelMultiplier: 1,
      touchMultiplier: 1.5
    });

    window.lenis = lenis;

    lenis.on('scroll', ScrollTrigger.update);

    gsap.ticker.add(function (time) {
      lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);
  } else if (lenis && typeof ScrollTrigger !== 'undefined') {
    lenis.on('scroll', ScrollTrigger.update);
  }

  // ============================================================
  // 2) STACKING CARDS
  //    Use native CSS sticky for the actual sticking behaviour. This is
  //    more reliable inside Shopify/Dawn than repeatedly pinning individual
  //    cards with ScrollTrigger, especially when sections are injected or
  //    resized by the theme editor. ScrollTrigger is only used here for
  //    light visual polish and to set stable z-index values.
  // ============================================================
  var stackSlides = gsap.utils.toArray('.mwg_effect031 .slide');
  if (stackSlides.length) {
    stackSlides.forEach(function (slide, i) {
      slide.style.zIndex = String(i + 1);
    });

    if (!isMobile && !prefersReducedMotion) {
      stackSlides.forEach(function (slide, i) {
        var isLast = i === stackSlides.length - 1;

        if (!isLast) {
          gsap.to(slide, {
            scale: 0.965,
            opacity: 0.86,
            ease: 'none',
            scrollTrigger: {
              trigger: stackSlides[i + 1],
              start: 'top bottom',
              end: 'top 35%',
              scrub: true,
              invalidateOnRefresh: true
            }
          });
        }
      });
    }
  }

  // ============================================================
  // 3) HEADING REVEALS
  //    SplitText (paid) gives us word-by-word stagger.
  //    Falls back to a simple opacity fade if SplitText is absent.
  // ============================================================
  var splitElements = document.querySelectorAll('[data-anim="split"]');
  splitElements.forEach(function (el) { el.classList.add('split-mask'); });

  if (typeof SplitText !== 'undefined' && !prefersReducedMotion) {
    splitElements.forEach(function (el) {
      var split = new SplitText(el, { type: 'words', wordsClass: 'word' });
      gsap.set(split.words, { yPercent: 110, opacity: 0 });
      ScrollTrigger.create({
        trigger: el,
        start: 'top 88%',
        once: true,
        onEnter: function () {
          gsap.to(split.words, {
            yPercent: 0,
            opacity: 1,
            duration: 0.9,
            ease: 'expo.out',
            stagger: 0.06
          });
        }
      });
    });
  } else {
    // No SplitText — fade-up the whole heading
    splitElements.forEach(function (el) {
      gsap.set(el, { y: 40, opacity: 0 });
      ScrollTrigger.create({
        trigger: el,
        start: 'top 88%',
        once: true,
        onEnter: function () {
          gsap.to(el, { y: 0, opacity: 1, duration: 0.9, ease: 'expo.out' });
        }
      });
    });
  }

  // ============================================================
  // 4) GENERIC FADE-UP for [data-anim="fade"]
  // ============================================================
  if (!prefersReducedMotion) {
    var fadeElements = gsap.utils.toArray('[data-anim="fade"]');
    fadeElements.forEach(function (el) {
      gsap.set(el, { y: 30, opacity: 0 });
      ScrollTrigger.create({
        trigger: el,
        start: 'top 90%',
        once: true,
        onEnter: function () {
          gsap.to(el, { y: 0, opacity: 1, duration: 0.9, ease: 'expo.out' });
        }
      });
    });
  } else {
    document.querySelectorAll('[data-anim]').forEach(function (el) { el.classList.add('is-in'); });
  }

  // ============================================================
  // 5) CTA-CARDS — sequential entry via ScrollTrigger
  //    Cards enter one-by-one as you scroll into the section,
  //    each from off-viewport into its tilted pile position.
  // ============================================================
  if (!prefersReducedMotion && !isMobile) {
    var pile = document.querySelector('.cta-cards-pile');
    if (pile) {
      var cards = pile.querySelectorAll('.cta-card');

      function readCardNumber(card, propertyName, fallback) {
        var value = getComputedStyle(card).getPropertyValue(propertyName).trim();
        var parsed = parseFloat(value);
        return Number.isFinite(parsed) ? parsed : fallback;
      }

      cards.forEach(function (card, i) {
        var finalX = readCardNumber(card, '--card-x', 0);
        var finalY = readCardNumber(card, '--card-y', 0);
        var finalR = readCardNumber(card, '--card-r', 0);

        gsap.set(card, {
          xPercent: 60,
          yPercent: 110,
          rotation: 12,
          opacity: 0
        });

        gsap.to(card, {
          xPercent: finalX,
          yPercent: finalY,
          rotation: finalR,
          opacity: 1,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: pile,
            start: 'top ' + (80 - i * 18) + '%',
            end:   'top ' + (45 - i * 18) + '%',
            scrub: 1,
            invalidateOnRefresh: true
          }
        });
      });
    }
  } else {
    document.querySelectorAll('.cta-card').forEach(function (el) {
      var finalX = getComputedStyle(el).getPropertyValue('--card-x').trim() || 0;
      var finalY = getComputedStyle(el).getPropertyValue('--card-y').trim() || 0;
      var finalR = getComputedStyle(el).getPropertyValue('--card-r').trim() || 0;
      el.style.transform = 'translate(' + finalX + '%, ' + finalY + '%) rotate(' + finalR + 'deg)';
      el.style.opacity = '1';
    });
  }

  // ============================================================
  // 6) NAV SCROLL STATE — toggle .is-scrolled when past hero
  // ============================================================
  var nav = document.querySelector('.osc-nav');
  if (nav) {
    var navThreshold = 80;
    var lastNavState = false;
    function updateNav() {
      var scrolled = (window.scrollY || document.documentElement.scrollTop) > navThreshold;
      if (scrolled !== lastNavState) {
        nav.classList.toggle('is-scrolled', scrolled);
        lastNavState = scrolled;
      }
    }
    updateNav();
    // Hook into Lenis if available, else listen to native scroll
    if (lenis) {
      lenis.on('scroll', updateNav);
    } else {
      window.addEventListener('scroll', updateNav, { passive: true });
    }
  }

  // ============================================================
  // 7) Refresh ScrollTrigger after fonts/images load to ensure
  //    pin calculations use final element heights.
  // ============================================================
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { ScrollTrigger.refresh(); });
  }
  window.addEventListener('load', function () { ScrollTrigger.refresh(); });
  window.addEventListener('resize', function () { ScrollTrigger.refresh(); });

})();
